import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function statusColor(status) {
    switch (status.toLowerCase()) {
        case 'active':
        case 'completed':
        case 'merged':
            return { bg: 'bg-green-100', text: 'text-green-800' };
        case 'planning':
        case 'paused':
            return { bg: 'bg-yellow-100', text: 'text-yellow-800' };
        case 'failed':
        case 'cancelled':
            return { bg: 'bg-red-100', text: 'text-red-800' };
        default:
            return { bg: 'bg-gray-100', text: 'text-gray-800' };
    }
}
function relativeTime(dateString) {
    const now = Date.now();
    const then = new Date(dateString).getTime();
    const diffMs = now - then;
    if (diffMs < 0)
        return 'just now';
    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1)
        return 'just now';
    if (minutes < 60)
        return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24)
        return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
}
export function ProjectCard({ project, onClick }) {
    const { bg, text } = statusColor(project.status);
    const completedTasks = project.tasks.completed;
    const totalTasks = project.tasks.total;
    const progressPct = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;
    return (_jsxs("div", { onClick: onClick, className: "bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:shadow-md transition-shadow cursor-pointer", children: [_jsxs("div", { className: "flex items-start justify-between gap-3 mb-3", children: [_jsx("h3", { className: "text-lg font-bold text-gray-900 truncate", children: project.name }), _jsx("span", { className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${bg} ${text}`, children: project.status })] }), _jsxs("div", { className: "mb-3", children: [_jsxs("div", { className: "flex items-center justify-between text-sm text-gray-600 mb-1", children: [_jsxs("span", { children: [completedTasks, "/", totalTasks, " completed"] }), _jsxs("span", { children: [progressPct, "%"] })] }), _jsx("div", { className: "w-full bg-gray-200 rounded-full h-1.5", children: _jsx("div", { className: "bg-blue-600 h-1.5 rounded-full transition-all", style: { width: `${progressPct}%` } }) })] }), _jsxs("div", { className: "flex items-center justify-between text-sm text-gray-500", children: [_jsx("div", { className: "flex items-center gap-1", children: project.workers.active > 0 && (_jsxs(_Fragment, { children: [_jsx("span", { className: "inline-block w-2 h-2 rounded-full bg-green-500" }), _jsxs("span", { children: [project.workers.active, " active worker", project.workers.active !== 1 ? 's' : ''] })] })) }), _jsx("span", { children: relativeTime(project.updatedAt) })] })] }));
}
